import { render, staticRenderFns } from "./subscription.vue?vue&type=template&id=08635572&scoped=true&"
import script from "./subscription.vue?vue&type=script&lang=js&"
export * from "./subscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08635572",
  null
  
)

export default component.exports